import FormImageInput from "@/components/forms/FormImageInput";
import FormInput from "@/components/forms/FormInput";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import * as Yup from "yup";
import { useCreateFeatureArticleMutation } from "@/app/features/FeatureArticle/featureArticleApiSlice";

const initialValues = {
  name: "",
  redirectionUrl: "",
};

const validationSchema = Yup.object().shape({
  name: Yup.string().required().min(2).max(50).label("Name").trim(),
  redirectionUrl: Yup.string().required().min(1).label("redirectionUrl").trim(),
  image: Yup.mixed()
    .required("Image is require")
    .test(
      "type",
      "Only the following formats are accepted: .jpg, .webp and.png",
      function (value) {
        return (
          value &&
          (value.type === "image/png" ||
            value.type === "image/jpg" ||
            value.type === "image/jpeg" ||
            value.type === "image/webp")
        );
      }
    )
    .label(""),
});

export default function CreateFeatureArticlePage() {
  const [createPost, { isLoading }] = useCreateFeatureArticleMutation();

  const navigate = useNavigate();

  const handleSubmit = async (inputs) => {
    try {
      const formData = new FormData();
      formData.append("name", inputs.name);
      formData.append("redirectionUrl", inputs.redirectionUrl);
      formData.append("image", inputs.image);

      const result = await createPost(formData);

      if (result && result.data) {
        toast.success(result.data.message);
        navigate("/feature-article");
      } else if (result && result.error) {
        toast.error(result.error.data.message);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 8,
      }}
    >
      <Container maxWidth="md">
        <Stack spacing={3}>
          <Stack direction="row" justifyContent="space-between" spacing={4}>
            <Typography variant="h4">Create Article Search</Typography>
          </Stack>

          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
          >
            {({
              setFieldValue,
              values,
              setFieldTouched,
              setFieldError,
              errors,
              resetForm,
            }) => (
              <Form>
                <Stack spacing={3}>
                  <FormInput
                    label="Name"
                    name="name"
                    type="text"
                    placeholder="Enter Name"
                  />
                  <FormInput
                    label="redirectionUrl"
                    name="redirectionUrl"
                    type="text"
                    placeholder="Enter redirectionUrl"
                  />
                  <FormImageInput
                    name="image"
                    imageValues={values.image}
                    onChangeSelectedImage={(event) => {
                      setFieldTouched(event.target.name);
                      setFieldValue(event.target.name, event.target.files[0]);
                    }}
                    onError={(message) => {
                      setFieldError("image", message);
                    }}
                    onCheckRes={(checkResolution) => {
                      setFieldValue("checkResolution", checkResolution);
                    }}
                    checkResolution={values.checkResolution}
                    label="Image"
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={isLoading}
                  >
                    Submit
                  </Button>
                </Stack>
              </Form>
            )}
          </Formik>
        </Stack>
      </Container>
    </Box>
  );
}
